import index from './js/index.js';

export default index;
